module.exports = __webpack_public_path__ + "static/media/Blur-asset-4.1cbca63b.png";